<template>
  <div class="mb-2 overflow-hidden rounded-lg border border-gray-200 bg-white" data-testid="qc-howto">
    <button
      type="button"
      class="flex w-full items-center gap-2 bg-gray-100 px-4 py-2.5 text-left text-sm font-medium text-gray-800"
      :aria-expanded="open"
      data-testid="qc-howto-toggle"
      @click="open = !open"
    >
      <span class="pi pi-chevron-right text-[0.7rem] text-gray-500 transition-transform" :class="{ 'rotate-90': open }" aria-hidden="true"></span>
      <span class="pi pi-info-circle text-sm" aria-hidden="true"></span>
      {{ $t('messages.evaluation.qualityCheck.howTo.title') }}
    </button>

    <div v-if="open" class="px-4 pb-4 pt-3 text-sm text-gray-500" data-testid="qc-howto-body">
      <table class="mb-2.5 mt-1 w-full border-collapse">
        <tbody>
          <tr v-for="row in severities" :key="row.slug" class="border-b border-gray-100">
            <td class="w-px whitespace-nowrap py-1.5 pr-2 align-top">
              <span class="pi mr-1" :class="[row.icon, row.colour]" aria-hidden="true"></span>
              <strong class="font-semibold text-gray-700">{{ $t(`messages.evaluation.qualityCheck.severity.${row.slug}`) }}</strong>
            </td>
            <td class="py-1.5 align-top">{{ $t(`messages.evaluation.qualityCheck.howTo.${row.slug}`) }}</td>
          </tr>
        </tbody>
      </table>

      <p class="mb-1 mt-2">
        <strong class="font-semibold text-gray-700">{{ $t('messages.evaluation.qualityCheck.howTo.basisLead') }}</strong>
        {{ $t('messages.evaluation.qualityCheck.howTo.basis') }}
      </p>
      <table class="mb-2.5 w-full border-collapse">
        <tbody>
          <tr v-for="kind in basisKinds" :key="kind.kind" class="border-b border-gray-100">
            <td class="w-px whitespace-nowrap py-1.5 pr-2 align-top"><QcBasisChip :kind="kind.kind" /></td>
            <td class="py-1.5 align-top">{{ $t(`messages.evaluation.qualityCheck.basisHint.${kind.slug}`) }}</td>
          </tr>
        </tbody>
      </table>

      <p class="mb-2.5 mt-2">
        <strong class="font-semibold text-gray-700">{{ $t('messages.evaluation.qualityCheck.howTo.limitsLead') }}</strong>
        {{ $t('messages.evaluation.qualityCheck.howTo.limits', { total: checksTotal }) }}
        {{ $t('messages.evaluation.qualityCheck.howTo.notTheFile') }}
      </p>

      <!-- BETA, place 3 of 3 (§17.5): the foot of this block. -->
      <QcBetaNote :support-email="supportEmail" />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import QcBasisChip from './QcBasisChip.vue'
import QcBetaNote from './QcBetaNote.vue'

/**
 * RED-351 rework — "Kuidas tähelepanekuid lugeda", collapsed under `Lisainfo`
 * below the list (prototype v3; Toomas, RED-340 comment 30633).
 */
defineProps({
  checksTotal: { type: Number, default: 22 },
  supportEmail: { type: String, required: true },
})

const open = ref(false)

const severities = [
  { slug: 'blokeeriv', icon: 'pi-ban', colour: 'text-red-600' },
  { slug: 'vajabParandust', icon: 'pi-exclamation-triangle', colour: 'text-amber-500' },
  { slug: 'soovituslik', icon: 'pi-lightbulb', colour: 'text-gray-500' },
]

// Surest first, the way the chips rank: 4/4 down to 1/4.
const basisKinds = [
  { kind: 'standard', slug: 'standard' },
  { kind: 'praktika', slug: 'praktika' },
  { kind: 'märkimata', slug: 'markimata' },
  { kind: 'mõlemad', slug: 'molemad' },
]
</script>
